import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import TowClampList from "./pages/TowClampList";
import TowClampCreate from "./pages/TowClampCreate";
import TowClampDetail from "./pages/TowClampDetail";
import PrivateRoute from "./routes/PrivateRoute";
import Layout from "./components/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>

          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Private */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <Home />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/tow-clamp"
            element={
              <PrivateRoute>
                <Layout>
                  <TowClampList />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/tow-clamp/create"
            element={
              <PrivateRoute>
                <Layout>
                  <TowClampCreate />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/tow-clamp/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <TowClampDetail />
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="bottom-center" />
    </>
  );
}

export default App;